exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:450px){.button-custom[data-v-56860121]{display:grid;margin-top:-50px}}.button-custom[data-v-56860121]{display:grid}.close-modal-button[data-v-56860121]{position:absolute;float:right;top:5px;right:20px;z-index:99}", ""]);

// exports
